module.exports = __webpack_public_path__ + "img/tutorial-10.7fdd6759.svg";